module.exports = __webpack_public_path__ + "static/media/roundedrect-disabled-wide.47943773.png";